import { render } from "./CompetenciesList.vue?vue&type=template&id=24763b95"
import script from "./CompetenciesList.vue?vue&type=script&lang=js"
export * from "./CompetenciesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__